import React, { Component } from 'react';
import { ToastContainer } from 'react-toastify';
import classNames from 'classnames';
import { ScrollPanel } from 'primereact/components/scrollpanel/ScrollPanel';
import AppTopbar from './AppTopbar';
import AppInlineProfile from './AppInlineProfile';
// import { AppFooter } from './AppFooter';
import { AppMenu } from './AppMenu';
import { withMenu } from '../../modules/Menu';
import Router from '../../modules/Router';
import { withRouter } from 'react-router-dom';

class Layout extends Component {
  state = {
    layoutCompact: true,
    overlayMenuActive: false,
    staticMenuDesktopInactive: false,
    staticMenuMobileActive: false,
    rotateMenuButton: false,
    topbarMenuActive: false,
    activeTopbarItem: null,
    darkMenu: false,
    menuActive: false,
    theme: 'blue',
    layout: 'blue',
    version: 'v4',
  };

  onMenuClick = () => {
    this.menuClick = true;
  }

  onMenuButtonClick = (event) => {
    this.menuClick = true;
    this.setState(({
      rotateMenuButton: !this.state.rotateMenuButton,
      topbarMenuActive: false
    }));
    if(this.props.layoutMode === 'overlay') {
      this.setState({
        overlayMenuActive: !this.state.overlayMenuActive
      });
    } else {
      if (this.isDesktop()) this.setState({
        staticMenuDesktopInactive: !this.state.staticMenuDesktopInactive
      });
      else this.setState({staticMenuMobileActive: !this.state.staticMenuMobileActive});
    }
    event.preventDefault();
  }

  onTopbarMenuButtonClick = (event) => {
      this.topbarItemClick = true;
      this.setState({topbarMenuActive: !this.state.topbarMenuActive});
      this.hideOverlayMenu();
      event.preventDefault();
  }

  onTopbarItemClick = (event) => {
    this.topbarItemClick = true;
    if (this.state.activeTopbarItem === event.item) this.setState({
      activeTopbarItem: null
    });
    else this.setState({ activeTopbarItem: event.item });
    event.originalEvent.preventDefault();
  }

  onMenuItemClick = (event) => {
    if (!event.item.items) this.hideOverlayMenu();
    if (!event.item.items && this.isHorizontal()) this.setState({
        menuActive: false
    });
  }

  onRootMenuItemClick = (event) => {
    this.setState({ menuActive: !this.state.menuActive });
  }

  onDocumentClick = (event) => {
    if(!this.topbarItemClick) {
      this.setState({
        activeTopbarItem: null,
        topbarMenuActive: false
      });
    }

    if(!this.menuClick) {
      if(this.isHorizontal() || this.isSlim()) this.setState({ menuActive: false })
      this.hideOverlayMenu();
    }
    if(!this.rightPanelClick) this.setState({ rightPanelActive: false })
    this.topbarItemClick = false;
    this.menuClick = false;
    this.rightPanelClick = false;
  }

  hideOverlayMenu = () => {
    this.setState({
      rotateMenuButton: false,
      overlayMenuActive: false,
      staticMenuMobileActive: false
    })
  }

  isTablet = () => {
    const width = window.innerWidth;
    return width <= 1024 && width > 640;
  }

  isDesktop = () => {
    return window.innerWidth > 1024;
  }

  isMobile = () => {
      return window.innerWidth <= 640;
  }

  isOverlay = () => {
      return this.props.layoutMode === 'overlay';
  }

  isHorizontal = () => {
      return this.props.layoutMode === 'horizontal';
  }

  isSlim = () => {
    return this.props.layoutMode === 'slim';
  }

  /**
   * Disabled, It needs <link id="layout" rel="stylesheet" />
   */
  changeTheme = (theme) => {
    this.setState({theme:theme});
    if(this.state.version === 'v3'){
      this.changeStyleSheetUrl('theme-css', theme, 'theme');
    } else {
      this.changeStyleSheetUrl('theme-css', theme+'-v4', 'theme');
    }
  }

  /**
   * Disabled, It needs <link id="layout" rel="stylesheet" />
   */
  changeLayout = (layout, special) => {
    this.setState({layout:layout});
    if(this.state.version === 'v3'){
        this.changeStyleSheetUrl('layout-css', layout, 'layout');
    } else {
        this.changeStyleSheetUrl('layout-css', layout+'-v4', 'layout');
    }

    if(special) {
        this.setState({
            darkMenu: true
        })
    }
  }

  /**
   * Disabled, It needs <link id="layout" rel="stylesheet" />
   */
  changeVersion = (version) => {
    this.setState({version:version});
    if (version === 'v3') {
      this.changeStyleSheetUrl('layout-css', this.state.layout, 'layout');
      this.changeStyleSheetUrl('theme-css', this.state.theme, 'theme');
    } else {
      this.changeStyleSheetUrl('layout-css', this.state.layout+'-v4', 'layout');
      this.changeStyleSheetUrl('theme-css', this.state.theme+'-v4', 'theme');
    }
  }

  /**
   * Disabled, It needs <link id="layout" rel="stylesheet" />
   */
  changeStyleSheetUrl(id, value, prefix) {
    // const element = document.getElementById(id);
    // const urlTokens = element.getAttribute('href').split('/');
    // urlTokens[urlTokens.length - 1] = prefix + '-' + value + '.css';
    // const newURL = urlTokens.join('/');
    // element.setAttribute('href', newURL);
  }

  render() {
    const { menu } = this.props;
    const layoutClassName = classNames('layout-wrapper', {
        'menu-layout-static': this.props.layoutMode !== 'overlay',
        'menu-layout-overlay': this.props.layoutMode === 'overlay',
        'layout-menu-overlay-active': this.state.overlayMenuActive,
        'menu-layout-slim': this.props.layoutMode === 'slim',
        'menu-layout-horizontal': this.props.layoutMode === 'horizontal',
        'layout-menu-static-inactive': this.state.staticMenuDesktopInactive,
        'layout-menu-static-active': this.state.staticMenuMobileActive
    });
    const menuClassName = classNames(
      'layout-menu-container',
      {'layout-menu-dark': this.state.darkMenu
    });

    return (
      <>
        <div className={layoutClassName} onClick={this.onDocumentClick}>
          <AppTopbar
            profileMode={this.props.profileMode}
            horizontal={this.isHorizontal()}
            topbarMenuActive={this.state.topbarMenuActive}
            activeTopbarItem={this.state.activeTopbarItem}
            onMenuButtonClick={this.onMenuButtonClick}
            onTopbarMenuButtonClick={this.onTopbarMenuButtonClick}
            onTopbarItemClick={this.onTopbarItemClick}
          />
          <div className={menuClassName} onClick={this.onMenuClick}>
            <ScrollPanel
              ref={(el) => this.layoutMenuScroller = el}
              style={{height: '100%'}}
            >
              <div className="menu-scroll-content">
                {
                  (this.props.profileMode === 'inline' && this.props.layoutMode !== 'horizontal')
                  && <AppInlineProfile />
                }
                {
                  !(this.props.location.pathname === "/" ||this.props.location.pathname === "/signIn") && (
                    <AppMenu
                      model={menu}
                      onMenuItemClick={this.onMenuItemClick}
                      onRootMenuItemClick={this.onRootMenuItemClick}
                      layoutMode={this.props.layoutMode}
                      active={this.state.menuActive}
                    />
                  )
                }
              </div>
            </ScrollPanel>
          </div>
          <main className="layout-main" >
            <Router />
          </main>
          <div className="layout-mask"></div>
        </div>
        <ToastContainer
          style={{
            marginTop: '60px',
          }}
          position="top-right"
          autoClose={5000}
          newestOnTop
          closeOnClick
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
      </>
    );
  }
}

export default withRouter(withMenu(Layout));
